import { Heart } from "lucide-react";
import { useWishlist } from "@/context/WishlistContext";
import { toast } from "sonner";

export const HeartButton = ({ property, size = "md", className = "" }) => {
  const { has, toggle } = useWishlist();
  const active = has(property.id);
  const dim = size === "lg" ? "w-11 h-11" : "w-9 h-9";
  return (
    <button type="button" aria-pressed={active} aria-label="Merken"
            data-testid={`wishlist-toggle-${property.slug}`}
            onClick={(e) => { e.preventDefault(); e.stopPropagation(); toggle(property.id); toast.success(active ? "Von der Merkliste entfernt" : "Zur Merkliste hinzugefügt"); }}
            className={`${dim} rounded-full bg-white/90 hover:bg-white shadow flex items-center justify-center transition-transform hover:scale-110 ${className}`}>
      <Heart className={`w-5 h-5 transition-colors ${active ? "fill-signal text-signal" : "text-stone-500"}`} />
    </button>
  );
};
